<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="remarks"
            rules="required"
          >
            <b-form-group
              label="root cause"
              label-for="root cause"
            >
              <b-form-input
                id="root_cause"
                v-model="responsibleForm.root_cause
                "
                trim
                placeholder="root cause"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="corrective_action"
            rules="required"
          >
            <b-form-group
              label="corrective action"
              label-for="corrective action"
            >
              <b-form-input
                id="root_cause"
                v-model="responsibleForm.corrective_action
                "
                trim
                placeholder="corrective action"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="closing_email"
            rules="required"
          >
            <b-form-group
              label="closing email"
              label-for="closing email"
            >
              <b-form-input
                id="root_cause"
                v-model="responsibleForm.closing_email
                "
                trim
                placeholder="closing email"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="accepted by responsible"
            rules="required"
          >
            <b-form-group
              label="accepted by responsible"
              label-for="accepted by responsible"
            >
              <b-form-checkbox
                id="accepted_by_responsible"
                v-model="responsibleForm.accepted_by_responsible"
                name="accepted by responsible"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addAdminInitial()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addAdminInitial()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import decryptData from '@/store/auth/decryptData'

export default {
  data() {
    return {
      required,
      loader: false,
      validationErrors: {},
      errors: {},
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const responsibleForm = ref({
    })
    return {
      getValidationState,
      responsibleForm,
    }
  },
  computed: {
    optionsUsers() {
      return this.$store.getters['generalData/engineersList/engineersList']
    },
  },
  async mounted() {
    if (!this.$store.getters['generalData/engineersList/engineersLoaded']) {
      await this.$store.dispatch('generalData/engineersList/fetchEngineersList')
    }
  },
  methods: {

    addAdminInitial() {
      this.loader = true
      // const formData = new FormData()

      // Object.entries(this.responsibleForm).forEach(([key, value]) => {
      //   formData.append(key, value)
      // })
      const payload = {
        ...this.responsibleForm,
      }

      axios
        .post(`complaints/${this.$route.params.id}/process/responsible`, payload)
        .then(res => {
          if (res.status === 200 || res.status === 201) {
            this.$router.push({ name: 'responsible-complaint' })
            this.$toasted.show('Assigned Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        })
        .catch(error => {
          if (error.response.status) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `${error.response.data.message}`,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        })
        .finally(() => {
          this.loader = false
        })
    },

  },
}
</script>
